import { render, staticRenderFns } from "./SubscriptionTable.vue?vue&type=template&id=2bbe99f5&scoped=true"
import script from "./SubscriptionTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionTable.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTable.vue?vue&type=style&index=0&id=2bbe99f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe99f5",
  null
  
)

export default component.exports